import * as React from 'react';

import Page from 'components/page/Page';
import PageSection from 'components/page/page-section/PageSection';
import PageHeading from 'components/page/page-heading/PageHeading';

import AddZalandoBrandForm from '../../components/add-zalando-brand-form/AddZalandoBrandForm';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./add-zalando-brand-page.i18n.json'));

const AddZalandoBrandForCrawling = () => (
  <Page documentTitle={__t('add_zalando_brand_page.title')}>
    <PageHeading heading={__t('add_zalando_brand_page.title')} />
    <PageSection>
      <AddZalandoBrandForm />
    </PageSection>
  </Page>
);

export default AddZalandoBrandForCrawling;
